// extracted by mini-css-extract-plugin
export default {"button":"Xo-z","reviewSort":"Yo-z"};